// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TrophyBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29 7.5h-2.5V7A2.5 2.5 0 0 0 24 4.5H8A2.5 2.5 0 0 0 5.5 7v.5H3A2.5 2.5 0 0 0 .5 10v2A5.506 5.506 0 0 0 6 17.5h.096a10.523 10.523 0 0 0 8.404 6.894V26.5H12a1.5 1.5 0 1 0 0 3h8a1.5 1.5 0 1 0 0-3h-2.5v-2.111c3.867-.564 7.066-3.275 8.375-6.889H26a5.506 5.506 0 0 0 5.5-5.5v-2A2.5 2.5 0 0 0 29 7.5ZM3.5 12v-1.5h2V14c0 .151 0 .301.011.451A2.5 2.5 0 0 1 3.5 12Zm20 1.887c0 4.167-3.339 7.582-7.442 7.613A7.5 7.5 0 0 1 8.5 14V7.5h15v6.387Zm5-1.887a2.5 2.5 0 0 1-2.015 2.453c.01-.188.015-.375.015-.566V10.5h2V12Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
